import { render, staticRenderFns } from "./SupplementTutor.vue?vue&type=template&id=544c8253"
import script from "./SupplementTutor.vue?vue&type=script&lang=js"
export * from "./SupplementTutor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports